<script setup>
import { ref, onMounted, watch } from "vue";

const props = defineProps({
    logo: String,
});

const emit = defineEmits(["selectImage"]);

const previewImage = ref(props.logo);
const logoInput = ref(logoInput);

function selectImage() {
    logoInput.value.click();
}

function pickFile(e) {
    let input = e.target;
    let file = input.files;
    if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
            previewImage.value = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        emit("selectImage", file[0]);
    }
}
</script>

<template>
    <div>
        <input
            type="file"
            id="logo-input"
            ref="logoInput"
            name="logo"
            @input="pickFile"
            class="text-oteoText bg-oteoInputBG border-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm pl-1 pr-3 mt-1 block w-full"
        />
        <span class="text-sm text-oteoText">Maximal 2MB und vom Typ JPG oder PNG. Das Logo wird bei Upload auf die Größe 200x200px zugeschnitten.</span>
    </div>

    <div
        class="image-preview-wrapper"
        :style="{ 'background-image': `url(${previewImage})` }"
        @click="selectImage"
    ></div>
</template>

<style scoped lang="scss">
#logo-input {
    padding-top: 0.29rem;
    padding-bottom: 0.29rem;

    &:focus {
        outline: none;
    }
}
.image-preview-wrapper {
    width: 200px;
    height: 200px;
    display: block;
    cursor: pointer;
    margin: 15px auto;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
}
</style>
